<template>
  <vx-card>
    <div class="vx-row w-full">
      <div class="vx-col md:w-1/2 w-full">
        <vs-upload ref="IdentityUpload" multiple text="Identıty" action="http://localhost:8001/CustomApi/Upload" @on-success="successUpload" />
        <vs-button class="ml-6" color="danger" type="border" icon-pack="feather" icon="icon-upload" @click="$refs.IdentityUpload.upload('all')">Upload All</vs-button>
      </div>    
      <!-- <div class="vx-col md:w-1/2 w-full">
        <vs-upload ref="IdentityUpload" :headers="headerData" multiple text="Identıty" action="http://localhost:8001/CustomApi/Upload" @on-success="successUpload" />
        <vs-button class="ml-6" color="danger" type="border" icon-pack="feather" icon="icon-upload" @click="$refs.IdentityUpload.upload('all')">Upload All</vs-button>
      </div>     -->
    </div>
  </vx-card>
</template>

<script>
import VxCard from '../../components/vx-card/VxCard.vue'
export default {
  components: { VxCard },
  data () {
    return {
      headerData: {'Access-Control-Allow-Origin':'http://localhost:8000', 'Access-Control-Allow-Credentials':'false' }

    }
  },
  methods:{
    successUpload () {
      this.$vs.notify({color:'success', title:'Upload Success', text:'Lorem ipsum dolor sit amet, consectetur'})
    }
  }
}
</script>
